// js
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../SecurityDetail';
import SecurityDetailPPTX from '../../../components/analytics/pptx/SecurityDetailPPTX';


export default connect(mapStateToProps, mapDispatchToProps)(SecurityDetailPPTX);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/SecurityDetailPPTX.js